import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { Auth } from "../../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import { globalConfig } from "../../../config/config";
import Pagination from "../../../utils/Paginate";
import TableLoader from "../../../Skeleton/TableLoader";
// const querystring = require("querystring");

const ListContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
//   const { token, userMetadata } = Auth.getUserMetadata();
const token = globalConfig.hardcoded_header;
  const [search, setSearch] = useState("");
//   const navigate = useNavigate();
  const [state, setState] = useState({
    contents: [],
    filteredContents: [],
  });

  useEffect(() => {
	    handleOnLoad();
  }, []);

  useEffect(() => {
	    handleSearch(search);
  }, [search]);

  const handleOnLoad = () => {

    axios
      .get(`${globalConfig.apiDatahubUrl}/contents`, token)
      .then((res) => {
        const contents = res.data;
        console.log(contents);
        setState({ ...state, contents: contents, filteredContents: contents });
        console.log(res.data[0]);
      })
      .catch((error) => {
      });
  };

  function onDelete(event) {
    let deleteID = event.target.id;
    try {
    
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/contents/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({ ...state, contents: [] });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({ ...state, contents: [] });
    handleOnLoad();
    // this.props.navigate.push("/list-content-descriptors");
    }catch(x){
    }
  }

  const handleSearch = (search) => {
    setCurrentPage(1);
    let URL = `${globalConfig.apiDatahubUrl}/contents?filter[where][or][0][contentName][regexp]=/(${search})/i`;
    
    
    axios.get(URL, apiHeader(token)).then((res) => {
      const contents = res.data;
      console.log(contents);
      setState({ ...state, filteredContents: contents });
      console.log(res.data[0]);
    }).catch(x => {
    });
  };

  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContents.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  // if (currentData.length===0){
  //   return <div>Loading</div>
  // }
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Catalog</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        	<Link to="/breeze/create-content">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map(
                  ({ contentId, contentName, contentDescription }) => {
                    return (
                      <tr>
                        <td>
                          <Link to={`/manage-content/${contentId}`}>
                            {contentId}
                          </Link>
                        </td>
                        <td>
                          <Link to={`/manage-content/${contentId}`}>
                            {contentName}
                          </Link>{" "}
                        </td>
                        <td>
                          {" "}
                          <Link to={`/manage-content/${contentId}`}>
                            {contentDescription}
                          </Link>
                        </td>
                        <td>
                          <button
                            className="btn btn-success"
                            onClick={() =>
                              navigate.push(`/manage-content/${contentId}`)
                            }
                          >
                            Edit{" "}
                          </button>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(4).fill(0).map((_, index) => (
                  	
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContents.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />
      </div>
    </form>
  );
};

export default ListContent;
